import { americas } from "./americas";
import { europe } from "./europe";
import { others } from "./others";

// Built from https://stripe.com/docs/billing/customer/tax-ids#supported-tax-id
// TODO: fetch this from Stripe API once they support it.
export const taxIdTypes = [...americas, ...europe, ...others].sort((a, b) =>
  a.label.localeCompare(b.label, "en", { sensitivity: "base" }),
);
